module.exports = __webpack_public_path__ + "static/media/maximize.a536247d.svg";